import React, { useState, useEffect } from 'react';
import { Upload, Send, Edit2, ArrowLeft } from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';

const HighwayFundRequestReceived = ({ }) => {
    const [section11FundData, setSection11FundData] = useState([]);
    const [section19FundData, setSection19FundData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Edit states - अलग-अलग sections के लिए
    const [editingIdSection11, setEditingIdSection11] = useState(null);
    const [editingIdSection19, setEditingIdSection19] = useState(null);

    const [formDataSection11, setFormDataSection11] = useState({
        requested_fund: '',
        received_fund: '',
        document: null
    });
    const [formDataSection19, setFormDataSection19] = useState({
        requested_fund: '',
        received_fund: '',
        document: null
    });

    const [showSendBackButton, setShowSendBackButton] = useState({});
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [proposalId, setProposalId] = useState(null);

    //Project Incharge
    const [showSendToProjectInchargeModal, setshowSendToProjectInchargeModal] = useState(false);
    // const [selectedSectionType, setSelectedSectionType] = useState('section11');  // कौन सा section send करना है
    const [selectedDocumentProjectIncharge, setselectedDocumentProjectIncharge] = useState(null);
    const [remarksProjectIncharge, setremarksProjectIncharge] = useState('Approved');
    const [sendingToProjectIncharge, setsendingToProjectIncharge] = useState(false);
    const [usersProjectInchargeAll, setusersProjectInchargeAll] = useState([]);
    const [loadingusersProjectIncharge, setLoadingusersProjectIncharge] = useState(false);
    const [selectedUserProjectIncharge, setselectedUserProjectIncharge] = useState('');
    const [requestedFundPI, setRequestedFundPI] = useState('');
    const [datePI, setDatePI] = useState('');
    const { language, translations } = useLanguage();

    // LAO
    const [showSendBackToLAOModal, setshowSendBackToLAOModal] = useState(false);
    const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);
    const [remarksLAO, setremarksLAO] = useState('Approved');
    const [sendingToLAO, setsendingToLAO] = useState(false);
    const [usersLAO, setusersLAO] = useState([]);
    const [loadingusersLAO, setLoadingusersLAO] = useState(false);
    const [selectedUserLAO, setselectedUserLAO] = useState('');
    const [hasSentToProjectIncharge, setHasSentToProjectIncharge] = useState(false);

    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
    const [selectedSectionType, setSelectedSectionType] = useState(null);
    const [currentLAOSection, setCurrentLAOSection] = useState(null);
    const [sentToLAOSection11, setSentToLAOSection11] = useState(false);
    const [sentToLAOSection19, setSentToLAOSection19] = useState(false);
    const [receivedFundLAO, setReceivedFundLAO] = useState('');
    const [receiveDateLAO, setReceiveDateLAO] = useState('');
    const [checkDate, setCheckDate] = useState('');
    const [checkAmount, setsetCheckAmount] = useState('');
    const [receiveAmount, setReceiveAmount] = useState('');
    const ROLES = {
        LAO: 3,
        PROJECT_INCHARGE: 18
    };
    const [selectedFundId, setSelectedFundId] = useState(null);
    useEffect(() => {
        const getProjectInfo = () => {
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project:', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return { id: projectId, name: projectName };
                } catch (e) {
                    console.error('Error parsing user data:', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
    }, []);

    useEffect(() => {
        const savedProposalId = localStorage.getItem('currentProposalId');
        if (savedProposalId) {
            setProposalId(savedProposalId);
        }
    }, []);

    useEffect(() => {
        if (currentProjectId && proposalId) {
            const wasSent = localStorage.getItem(`fundSent_${proposalId}`) === 'true';
            setHasSentToProjectIncharge(wasSent);
            fetchFundData();
            fetchProjectInchargeUsers();
            fetchLAOUsers();
        }
    }, [currentProjectId, proposalId]);

    useEffect(() => {
        if (currentProjectId && proposalId) {
            const wasSent = localStorage.getItem(`fundSent_${proposalId}`) === 'true';
            setHasSentToProjectIncharge(wasSent);

            // ADD THESE LINES:
            const sentSection11 = localStorage.getItem(`fundSentToLAO_Section11_${proposalId}`) === 'true';
            const sentSection19 = localStorage.getItem(`fundSentToLAO_Section19_${proposalId}`) === 'true';
            setSentToLAOSection11(sentSection11);
            setSentToLAOSection19(sentSection19);

            fetchFundData();
            fetchProjectInchargeUsers();
            fetchLAOUsers();
        }
    }, [currentProjectId, proposalId]);

    const fetchFundData = async () => {
        if (!currentProjectId || !proposalId) {
            console.warn('Project ID or Proposal ID not available');
            return;
        }

        setLoading(true);
        try {
            // Common API call for both sections
            const [response11, response19] = await Promise.all([
                apiService.getFundRequestReceivedSection11(currentProjectId, proposalId),
                apiService.getFundRequestReceivedSection19(currentProjectId, proposalId),
            ]);

            console.log('Section 11 Data:', response11.data);
            console.log('Section 19 Data:', response19.data);

            setSection11FundData(response11.data || []);
            setSection19FundData(response19.data || []);

            // Combined sendBackStatus - Changed from .id to .fund_id
            const sendBackStatus = {};
            [...(response11.data || []), ...(response19.data || [])].forEach(item => {
                sendBackStatus[item.fund_id] = item.sent_back || false; // Changed from item.id to item.fund_id
            });
            setShowSendBackButton(sendBackStatus);

        } catch (error) {
            console.error('Error fetching fund data:', error);
            alert('Failed to fetch fund data');
        } finally {
            setLoading(false);
        }
    };

    // Format date to DD/MM/YYYY
    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (e) {
            return dateString;
        }
    };

    const fetchProjectInchargeUsers = async () => {
        setLoadingusersProjectIncharge(true);
        try {
            const response = await apiService.getAllUserRoleProjectIncharge(18);
            setusersProjectInchargeAll(response.data || []);
        } catch (error) {
            console.error('Error fetching Project Incharge users:', error);
        } finally {
            setLoadingusersProjectIncharge(false);
        }
    };

    const fetchLAOUsers = async () => {
        setLoadingusersLAO(true);
        try {
            const response = await apiService.getHighwayLAOButton(3);
            setusersLAO(response.data || []);
        } catch (error) {
            console.error('Error fetching LAO users:', error);
        } finally {
            setLoadingusersLAO(false);
        }
    };

    // Section 11 handlers
    const handleEditClickSection11 = (fund) => {
        setEditingIdSection11(fund.id);
        setFormDataSection11({
            requested_fund: fund.requested_fund,
            received_fund: fund.received_fund,
            document: null
        });
    };

    const handleUpdateFundRequestSection11 = async (fundId) => {
        if (!formDataSection11.requested_fund || !formDataSection11.received_fund) {
            alert('Please fill in all required fields');
            return;
        }

        setLoading(true);
        try {
            const data = new FormData();
            data.append('requested_fund', formDataSection11.requested_fund);
            data.append('received_fund', formDataSection11.received_fund);
            data.append('fundId', formDataSection19.fundId);
            if (formDataSection11.document) {
                data.append('document', formDataSection11.document);
            }

            await apiService.patchUpdateFundRequestReceived(fundId, data);

            setEditingIdSection11(null);
            setFormDataSection11({ requested_fund: '', received_fund: '', document: null, fundId: "" });
            fetchFundData();
            alert('Fund request updated successfully!');
        } catch (error) {
            console.error('Error updating fund request:', error);
            alert('Failed to update fund request');
        } finally {
            setLoading(false);
        }
    };

    // Section 19 handlers
    const handleEditClickSection19 = (fund) => {
        setEditingIdSection19(fund.id);
        setFormDataSection19({
            requested_fund: fund.requested_fund,
            received_fund: fund.received_fund,
            document: null
        });
    };

    const handleUpdateFundRequestSection19 = async (fundId) => {
        if (!formDataSection19.requested_fund || !formDataSection19.received_fund) {
            alert('Please fill in all required fields');
            return;
        }

        setLoading(true);
        try {
            const data = new FormData();
            data.append('requested_fund', formDataSection19.requested_fund);
            data.append('received_fund', formDataSection19.received_fund);
            data.append('fundId', formDataSection19.fundId);
            if (formDataSection19.document) {
                data.append('document', formDataSection19.document);
            }

            await apiService.patchUpdateFundRequestReceived(fundId, data);

            setEditingIdSection19(null);
            setFormDataSection19({ requested_fund: '', received_fund: '', receive_date: "", document: null, fundId: "" });
            fetchFundData();
            alert('Fund request updated successfully!');
        } catch (error) {
            console.error('Error updating fund request:', error);
            alert('Failed to update fund request');
        } finally {
            setLoading(false);
        }
    };

    const handleSendToProjectIncharge = async () => {
        if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge || !requestedFundPI || !datePI) {
            alert('Please fill in all required fields');
            return;
        }

        if (!currentProjectId || !proposalId) {
            alert('Project ID or Proposal ID not available');
            return;
        }

        if (!selectedSectionType) {
            alert('Section type not specified');
            return;
        }

        setsendingToProjectIncharge(true);
        try {
            const fundData = new FormData();
            fundData.append('project_id', currentProjectId);
            fundData.append('proposal_id', proposalId);
            fundData.append('requested_fund', requestedFundPI);
            fundData.append('received_fund', '0');
            fundData.append('date', datePI);
            fundData.append('type', selectedSectionType); // Add type here

            if (selectedDocumentProjectIncharge) {
                fundData.append('document', selectedDocumentProjectIncharge);
            }

            // Call appropriate API based on section
            if (selectedSectionType === 'section11') {
                await apiService.postAddFundRequestReceivedSection11(fundData);
            } else if (selectedSectionType === 'section19') {
                await apiService.postAddFundRequestReceivedSection19(fundData);
            }

            const trackingData = new FormData();
            trackingData.append('project_id', currentProjectId);
            trackingData.append('proposal_id', proposalId);
            trackingData.append('usr_id', selectedUserProjectIncharge);
            trackingData.append('remarks', remarksProjectIncharge);
            trackingData.append('document', selectedDocumentProjectIncharge);

            // Different tracking name based on section
            const trackingName = selectedSectionType === 'section11'
                ? 'ProjectInchargeFundSection11'
                : 'ProjectInchargeFundSection19';

            await apiService.postTrackingSendToProjectIncharge(trackingData, trackingName);

            alert(`Successfully sent to Project Incharge (${selectedSectionType})!`);

            setHasSentToProjectIncharge(true);
            setshowSendToProjectInchargeModal(false);
            setselectedUserProjectIncharge('');
            setremarksProjectIncharge('Approved');
            setselectedDocumentProjectIncharge(null);
            setRequestedFundPI('');
            setDatePI('');
            setSelectedSectionType(null); // Reset

            fetchFundData();
            localStorage.setItem(`fundSent_${proposalId}`, 'true');
        } catch (error) {
            console.error('Error sending to Project Incharge:', error);
            alert('Failed to send to Project Incharge');
        } finally {
            setsendingToProjectIncharge(false);
        }
    };

    const handleSendBackToLAO = async () => {
        if (!selectedUserLAO || !selectedDocumentLAO || !receivedFundLAO || !receiveDateLAO) {
            alert('Please fill in all required fields');
            return;
        }

        if (!currentProjectId || !proposalId) {
            alert('Project ID or Proposal ID not available');
            return;
        }

        if (!currentLAOSection) {
            alert('Section type not specified');
            return;
        }

        setsendingToLAO(true);
        try {
            const currentData = currentLAOSection === 'section11' ? section11FundData : section19FundData;

            if (!currentData || currentData.length === 0) {
                alert('No fund data available');
                setsendingToLAO(false);
                return;
            }

            const fundId = selectedFundId || currentData[0].fund_id;

            if (!fundId) {
                alert('Fund ID not found');
                setsendingToLAO(false);
                return;
            }

            // ADD THIS VALIDATION: Check if received_fund <= requested_fund
            const currentFund = currentData.find(f => f.fund_id === fundId);
            const requestedFund = parseFloat(currentFund?.requested_fund || 0);
            const receivedFund = parseFloat(receivedFundLAO);

            if (receivedFund > requestedFund) {
                alert(`प्राप्त निधी (₹${receivedFund.toLocaleString()}) निधी मागणी (₹${requestedFund.toLocaleString()}) पेक्षा जास्त असू शकत नाही!\n\nReceived Fund (₹${receivedFund.toLocaleString()}) cannot be greater than Requested Fund (₹${requestedFund.toLocaleString()})!`);
                setsendingToLAO(false);
                return;
            }
                
            // Create FormData and append all fields
            const updateData = new FormData();
            updateData.append('received_fund', receivedFundLAO);
            updateData.append('receive_date', receiveDateLAO);

            // Only append cheque date if it has a value
            if (checkDate) {
                updateData.append('cheque_date', checkDate);
            }

            // Only append cheque amount if it has a value
            if (checkAmount) {
                updateData.append('cheque_amount', checkAmount);
            }

            // Change field name to receive_amount instead of cheque_clearing_date
            if (receiveAmount) {
                updateData.append('receive_amount', receiveAmount);
            }

            if (selectedDocumentLAO) {
                updateData.append('document', selectedDocumentLAO);
            }

            // Call PATCH API to update fund request
            await apiService.patchUpdateFundRequestReceived(fundId, updateData);

            // Send tracking to LAO
            const trackingData = new FormData();
            trackingData.append('project_id', currentProjectId);
            trackingData.append('proposal_id', proposalId);
            trackingData.append('usr_id', selectedUserLAO);
            trackingData.append('remarks', remarksLAO);
            trackingData.append('document', selectedDocumentLAO);

            if (currentLAOSection === 'section11') {
                await apiService.postTrackingFundSendToLAOSection11(trackingData, 'LAOFundSection11');
                localStorage.setItem(`fundSentToLAO_Section11_${proposalId}`, 'true');
                setSentToLAOSection11(true);
            } else if (currentLAOSection === 'section19') {
                await apiService.postTrackingFundSendToLAOSection19(trackingData, 'LAOFundSection19');
                localStorage.setItem(`fundSentToLAO_Section19_${proposalId}`, 'true');
                setSentToLAOSection19(true);
            }

            alert('Successfully sent back to LAO!');

            // Reset modal state
            setshowSendBackToLAOModal(false);
            setselectedUserLAO('');
            setremarksLAO('Approved');
            setselectedDocumentLAO(null);
            setReceivedFundLAO('');
            setReceiveDateLAO('');
            setCheckDate('');
            setsetCheckAmount('');
            setReceiveAmount('');
            setCurrentLAOSection(null);
            setSelectedFundId(null);

            fetchFundData();
        } catch (error) {
            console.error('Error sending back to LAO:', error);
            alert('Failed to send back to LAO');
        } finally {
            setsendingToLAO(false);
        }
    };

    // Reusable Table Component
    const FundTable = ({ data, editingId, formData, onEdit, onUpdate, onInputChange, onFileChange, onCancel, sectionType }) => (
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-100 border-b">
                        <tr>
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.FundRequestDate || 'Request Date'}
                            </th>
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.FundRequest || 'Fund Request'}
                            </th>
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.ReciveFund || 'Received Fund'}
                            </th>
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.ChequeDate || 'Cheque Date'}
                            </th>
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.ChequeAmount || 'Cheque Amount'}
                            </th>
                            {/* <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.ReceiveAmount || 'Receive Amount'}
                            </th> */}
                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.ReceiveFundDate || 'Receive Date'}
                            </th>

                            <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                                {translations[language]?.Action || 'Action'}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {loading && data.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="px-6 py-7 text-center text-gray-500">
                                    Loading...
                                </td>
                            </tr>
                        ) : data.length === 0 ? (
                            <tr className="hover:bg-gray-50">
                                <td colSpan="6" className="px-6 py-7 text-center text-gray-500">
                                    No fund requests found
                                </td>
                                <td className="px-6 py-4 text-center">
                                    {userRole === ROLES.LAO && (
                                        <button
                                            onClick={() => {
                                                setSelectedSectionType(sectionType);
                                                setshowSendToProjectInchargeModal(true);
                                            }}
                                            disabled={loading}
                                            className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors"
                                        >
                                            <ArrowLeft size={16} />
                                            {translations[language]?.SendToProjectIncharge || 'Send to Project Incharge'}
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ) : (
                            data.map((fund) => (
                                <tr key={fund.fund_id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        {formatDateToDDMMYYYY(fund.date)}
                                    </td>
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        ₹{fund.requested_fund?.toLocaleString() || '0'}
                                    </td>
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        ₹{fund.received_fund?.toLocaleString() || '0'}
                                    </td>
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        {fund.cheque_date ? formatDateToDDMMYYYY(fund.cheque_date) : '-'}
                                    </td>
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        {fund.cheque_amount ? `${fund.cheque_amount.toLocaleString()}` : '-'}
                                    </td>
                                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        {fund.receive_date ? formatDateToDDMMYYYY(fund.receive_date) : '-'}
                                    </td>
                                    {/* <td className="px-6 py-4 text-center text-sm text-gray-900">
                                        {formatDateToDDMMYYYY(fund.cheque_clearing_date)}
                                    </td> */}
                                    <td className="px-6 py-4 text-center">
                                        <div className="flex justify-center gap-2">
                                            {userRole === ROLES.LAO && (
                                                <button
                                                    onClick={() => {
                                                        setSelectedSectionType(sectionType);
                                                        setshowSendToProjectInchargeModal(true);
                                                    }}
                                                    disabled={loading}
                                                    className="flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:bg-gray-400 transition-colors"
                                                >
                                                    <ArrowLeft size={16} />
                                                    {translations[language]?.SendToProjectIncharge || 'Send to Project Incharge'}
                                                </button>
                                            )}

                                            {userRole === ROLES.PROJECT_INCHARGE && (
                                                <button
                                                    onClick={() => {
                                                        setSelectedFundId(fund.fund_id);
                                                        setReceivedFundLAO(fund.received_fund || '');
                                                        setReceiveDateLAO(fund.receive_date ? fund.receive_date.split('T')[0] : '');
                                                        openSendToLAOModal(sectionType);
                                                    }}
                                                    disabled={loading}
                                                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
                                                >
                                                    <Send size={16} />
                                                    {translations[language]?.sendToLAO || 'Send to LAO'}
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {editingId && userRole === ROLES.LAO && (
                <div className="p-6 bg-gray-50 border-t">
                    <h3 className="text-lg font-semibold mb-4">Edit Fund Request</h3>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {translations[language]?.FundRequest || 'Fund Request'}*
                            </label>
                            <input
                                type="number"
                                name="requested_fund"
                                value={formData.requested_fund}
                                onChange={onInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Enter requested amount"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {translations[language]?.ReciveFund || 'Received Fund'}
                            </label>
                            <input
                                type="number"
                                name="received_fund"
                                value={formData.received_fund}
                                onChange={onInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Enter received amount"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {translations[language]?.ChequeDate || 'Cheque Date'}
                            </label>
                            <input
                                type="date"
                                name="cheque_date"
                                value={formData.cheque_date}
                                onChange={onInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {translations[language]?.ChequeAmount || 'Cheque Amount'}
                            </label>
                            <input
                                type="number"
                                name="cheque_amount"
                                value={formData.cheque_amount}
                                onChange={onInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Enter cheque amount"
                            />
                        </div>
                        {/* 
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {translations[language]?.ReceiveAmount || 'Receive Amount'}
                            </label>
                            <input
                                type="number"
                                name="receive_amount"
                                value={formData.receive_amount}
                                onChange={onInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Enter receive amount"
                            />
                        </div> */}

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Document (Optional)
                            </label>
                            <div className="flex items-center gap-2">
                                <input
                                    type="file"
                                    onChange={onFileChange}
                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                                <Upload size={20} className="text-gray-400" />
                            </div>
                        </div>

                        <div className="col-span-2 flex gap-2">
                            <button
                                onClick={() => onUpdate(editingId)}
                                disabled={loading}
                                className="flex-1 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors font-medium"
                            >
                                {loading ? 'Updating...' : 'Update Fund Request'}
                            </button>
                            <button
                                onClick={onCancel}
                                className="px-6 bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600 transition-colors font-medium"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    if (!currentProjectId || !proposalId) {
        return (
            <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
                <div className="bg-white rounded-lg shadow-md p-6 text-center">
                    <p className="text-gray-600">Loading project and proposal information...</p>
                </div>
            </div>
        );
    }

    const openSendToLAOModal = (section) => {
        setCurrentLAOSection(section);
        setshowSendBackToLAOModal(true);
    };

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen space-y-8">
            {/* Section 11 */}
            <div>
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-bold text-gray-800">
                            कलम 19 ची घोषणा करिता आवश्यक निधी मागणी
                        </h2>
                        <div className="flex items-center gap-3">
                            {/* {userRole === ROLES.PROJECT_INCHARGE && (
                                <button
                                    onClick={() => openSendToLAOModal('section11')}
                                    disabled={loading || sentToLAOSection11}
                                    className={`flex items-center gap-2 px-6 py-2 rounded-lg transition-colors ${sentToLAOSection11
                                        ? 'bg-red-600 hover:bg-red-700'
                                        : 'bg-blue-600 hover:bg-blue-700'
                                        } text-white disabled:bg-gray-400`}
                                >
                                    <Send size={18} />
                                    {sentToLAOSection11
                                        ? (translations[language]?.sentToLAO || 'Sent to LAO')
                                        : (translations[language]?.sendToLAO || 'Send to LAO')
                                    }
                                </button>
                            )} */}

                            {/* {userRole === ROLES.LAO && (
                                <button
                                    onClick={() => {
                                        setSelectedSectionType('section11');
                                        setshowSendToProjectInchargeModal(true);
                                    }}
                                    disabled={loading}
                                    className="flex items-center gap-2 bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700 disabled:bg-gray-400"
                                >
                                    <ArrowLeft size={18} />
                                    {translations[language]?.SendToProjectIncharge || 'Send to Project Incharge'}
                                </button>
                            )} */}
                        </div>
                    </div>
                </div>

                <FundTable
                    data={section11FundData}
                    editingId={editingIdSection11}
                    formData={formDataSection11}
                    onEdit={handleEditClickSection11}
                    onUpdate={handleUpdateFundRequestSection11}
                    onInputChange={(e) => {
                        const { name, value } = e.target;
                        setFormDataSection11(prev => ({ ...prev, [name]: value }));
                    }}
                    onFileChange={(e) => {
                        setFormDataSection11(prev => ({ ...prev, document: e.target.files[0] }));
                    }}
                    onCancel={() => {
                        setEditingIdSection11(null);
                        setFormDataSection11({ requested_fund: '', received_fund: '', receive_date: '', document: null });
                    }}
                    sectionType="section11"
                />
            </div>

            {/* Section 19 */}
            <div>
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-bold text-gray-800">
                            अंतिमनिवाडा करिता आवश्यक निधी मागणी
                        </h2>
                        <div className="flex items-center gap-3">
                            {/* {userRole === ROLES.PROJECT_INCHARGE && (
                                <button
                                    onClick={() => openSendToLAOModal('section19')}
                                    disabled={loading || sentToLAOSection19}
                                    className={`flex items-center gap-2 px-6 py-2 rounded-lg transition-colors ${sentToLAOSection19
                                        ? 'bg-red-600 hover:bg-red-700'
                                        : 'bg-blue-600 hover:bg-blue-700'
                                        } text-white disabled:bg-gray-400`}
                                >
                                    <Send size={18} />
                                    {sentToLAOSection19
                                        ? (translations[language]?.sentToLAO || 'Sent to LAO')
                                        : (translations[language]?.sendToLAO || 'Send to LAO')
                                    }
                                </button>
                            )} */}

                            {/* {userRole === ROLES.LAO && (
                                <button
                                    onClick={() => {
                                        setSelectedSectionType('section19');
                                        setshowSendToProjectInchargeModal(true);
                                    }}
                                    disabled={loading}
                                    className="flex items-center gap-2 bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700 disabled:bg-gray-400"
                                >
                                    <ArrowLeft size={18} />
                                    {translations[language]?.SendToProjectIncharge || 'Send to Project Incharge'}
                                </button>
                            )} */}
                        </div>
                    </div>
                </div>

                <FundTable
                    data={section19FundData}
                    editingId={editingIdSection19}
                    formData={formDataSection19}
                    onEdit={handleEditClickSection19}
                    onUpdate={handleUpdateFundRequestSection19}
                    onInputChange={(e) => {
                        const { name, value } = e.target;
                        setFormDataSection19(prev => ({ ...prev, [name]: value }));
                    }}
                    onFileChange={(e) => {
                        setFormDataSection19(prev => ({ ...prev, document: e.target.files[0] }));
                    }}
                    onCancel={() => {
                        setEditingIdSection19(null);
                        setFormDataSection19({ requested_fund: '', received_fund: '', document: null });
                    }}
                    sectionType="section19"
                />
            </div>

            {/* Send to ProjectIncharge Modal - Works for both sections */}
            {showSendToProjectInchargeModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <h2 className="text-xl font-bold text-gray-800 mb-4">
                                {selectedSectionType === 'section11'
                                    ? (translations[language]?.SendToProjectIncharge11 || 'Send to Project Incharge - Section 11')
                                    : (translations[language]?.SendToProjectIncharge19 || 'Send to Project Incharge - Section 19')
                                }
                            </h2>

                            <div className="space-y-4">
                                {/* Requested Fund */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.RequestedFund}*
                                    </label>
                                    <input
                                        type="number"
                                        value={requestedFundPI}
                                        onChange={(e) => setRequestedFundPI(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter requested fund amount"
                                    />
                                </div>

                                {/* Date */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.FundRequestDate}*
                                    </label>
                                    <input
                                        type="date"
                                        value={datePI}
                                        onChange={(e) => setDatePI(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>

                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectProjectIncharge}*
                                    </label>
                                    <select
                                        value={selectedUserProjectIncharge}
                                        onChange={(e) => setselectedUserProjectIncharge(e.target.value)}
                                        disabled={loadingusersProjectIncharge}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersProjectIncharge ? 'Loading Users...' : 'Select User'}
                                        </option>
                                        {usersProjectInchargeAll.map((user) => (
                                            <option key={user.usr_id} value={user.usr_id}>
                                                {user.full_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.REMARKS}
                                    </label>
                                    <textarea
                                        value={remarksProjectIncharge}
                                        onChange={(e) => setremarksProjectIncharge(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument}*
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentProjectIncharge(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendToProjectInchargeModal(false);
                                        setselectedUserProjectIncharge('');
                                        setremarksProjectIncharge('Approved');
                                        setselectedDocumentProjectIncharge(null);
                                        setRequestedFundPI('');
                                        setDatePI('');
                                        setSelectedSectionType(null); // Reset section type
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToProjectIncharge}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSendToProjectIncharge}
                                    disabled={sendingToProjectIncharge || !selectedUserProjectIncharge || !selectedDocumentProjectIncharge || !requestedFundPI || !datePI}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToProjectIncharge ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.send}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSendBackToLAOModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <h2 className="text-xl font-bold text-gray-800 mb-4">
                                {translations[language]?.SendBackToLAO || 'Send Back to LAO'}
                            </h2>

                            <div className="space-y-4">
                                {/* Received Fund */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.ReciveFund}*
                                    </label>
                                    <input
                                        type="number"
                                        value={receivedFundLAO}
                                        onChange={(e) => setReceivedFundLAO(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter received fund amount"
                                    />
                                </div>

                                {/* Date */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.ReceiveFundDate}*
                                    </label>
                                    <input
                                        type="date"
                                        value={receiveDateLAO}
                                        onChange={(e) => setReceiveDateLAO(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>
                                {/* Cheque Date */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.ChequeDate}*
                                    </label>
                                    <input
                                        type="date"
                                        value={checkDate}
                                        onChange={(e) => setCheckDate(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>
                                {/* Cheque Amount */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.ChequeAmount}*
                                    </label>
                                    <input
                                        type="number"
                                        value={checkAmount}
                                        onChange={(e) => setsetCheckAmount(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>
                                {/* Receive Amount */}
                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.ReceiveAmount}*
                                    </label>
                                    <input
                                        type="number"
                                        value={receiveAmount}
                                        onChange={(e) => setReceiveAmount(e.target.value)}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div> */}
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectLAOOfficer || 'Select LAO Officer'}*
                                    </label>
                                    <select
                                        value={selectedUserLAO}
                                        onChange={(e) => setselectedUserLAO(e.target.value)}
                                        disabled={loadingusersLAO}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersLAO ? 'Loading Users...' : 'Select User'}
                                        </option>
                                        {usersLAO.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks || 'Remarks'}
                                    </label>
                                    <textarea
                                        value={remarksLAO}
                                        onChange={(e) => setremarksLAO(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument || 'Upload Document'}*
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentLAO(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendBackToLAOModal(false);
                                        setselectedUserLAO('');
                                        setremarksLAO('Approved');
                                        setselectedDocumentLAO(null);
                                        setReceivedFundLAO('');
                                        setReceiveDateLAO('');
                                        setCurrentLAOSection(null);
                                        setSelectedFundId(null); // Add this line
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToLAO}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSendBackToLAO}
                                    disabled={sendingToLAO || !selectedUserLAO || !selectedDocumentLAO || !receivedFundLAO || !receiveDateLAO}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToLAO ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.Sending || 'Sending'}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.send || 'Send'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default HighwayFundRequestReceived;